import {
  FilterMode,
  InterpreterCreateMutationVariables,
  Interpreter_OrderBy,
  Interpreter,
  SortOrder,
  Interpreter_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const interpreterService = {
  createOne: buildCreateOne(
    (interpreterCreateVariables: InterpreterCreateMutationVariables) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.interpreterCreate(interpreterCreateVariables);
        return result.interpreterCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.interpreterOne({ id });
    return result.interpreterOne as Interpreter;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: Interpreter_OrderBy[] | null = null,
    filter: Interpreter_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: Interpreter_Filter | undefined;
    if (searchValue !== "") {
      where = { name: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.interpreterListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ name: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.interpreterListWithOffset
    ) as Interpreter[];
    return { list, orderBy };
  },
};
